module.exports = __webpack_public_path__ + "img/lengow.00d13822.png";